import store from "@/store/store";

// keys for local storage
var keys = {
  access_token: 'access-token',
  refresh_token: 'refresh-token',
  user_info: 'user-info',
  language_preference: 'language-preference',
  program_code: 'program_code',
};

// setters
var setAccessToken = function (token) {
  localStorage.setItem(keys.access_token, token);
};
var setRefreshToken = function (refresh_token) {
  localStorage.setItem(keys.refresh_token, refresh_token);
};
var setUserInfo = function (user_info) {
  localStorage.setItem(keys.user_info, JSON.stringify(user_info));
};
var setLanguagePreference = function (language_preference) {
  localStorage.setItem(keys.language_preference, language_preference);
};
var setProgramCodeInfo = function (program_code) {
  localStorage.setItem(keys.program_code, program_code);
};


// getters
var getAccessToken = function () {
  return localStorage.getItem(keys.access_token);
};
var getRefreshToken = function () {
  return localStorage.getItem(keys.refresh_token);
};
var getUserInfo = function () {
  var user_info = localStorage.getItem(keys.user_info);
  if (user_info == 'undefined') {
    return null;
  }
  return user_info ? JSON.parse(localStorage.getItem(keys.user_info)) : null;
};
var getLanguagePreference = function () {
  var language_preference = localStorage.getItem(keys.language_preference);
  return language_preference ? language_preference : 'en';
};
var getProgramCodeInfo = function () {
  var program_code = localStorage.getItem(keys.program_code);
  return program_code && program_code !== 'null' ? program_code : null;
};

// helpers

var setItemsInStore = function () {
  store.dispatch("updateAccessToken", getAccessToken());
  store.dispatch("updateRefreshToken", getRefreshToken());
  store.dispatch("updateUserInfo", getUserInfo());
  store.dispatch("updateLanguagePreference", getLanguagePreference()); 
  store.dispatch("updateProgramCodeInfo", getProgramCodeInfo());
}

var isAuthenticated = function () {
  if (getAccessToken() && getRefreshToken() && getUserInfo()) {
    return true;
  }
  return false;
}


var clearAndLogout = function () {
  // remove everything from local storage
  localStorage.removeItem(keys.access_token);
  localStorage.removeItem(keys.refresh_token);
  localStorage.removeItem(keys.user_info);
  localStorage.removeItem(keys.language_preference);
  localStorage.removeItem(keys.program_code);
  localStorage.removeItem('admin_token_previous');
  localStorage.removeItem('admin_user_previous');

  // go to base url (right now login screen)
  location.href = process.env.BASE_URL ? process.env.BASE_URL : '/';
}

export default {
  // setters
  setAccessToken,
  setRefreshToken,
  setUserInfo,
  setLanguagePreference,
  setProgramCodeInfo,

  // getters
  getAccessToken,
  getRefreshToken,
  getUserInfo,
  getLanguagePreference,
  getProgramCodeInfo,

  // helpers
  setItemsInStore,
  isAuthenticated,
  clearAndLogout
}
